module.exports = "https://cdn.dove.it/_next/static/public/assets/cities/small/prato.b85a9b158feb82ee44927f1bdc02cadc.jpg";